import { render, staticRenderFns } from "./floors.vue?vue&type=template&id=4b2f23b2&lang=pug&"
import script from "./floors.vue?vue&type=script&lang=js&"
export * from "./floors.vue?vue&type=script&lang=js&"
import style0 from "./floors.vue?vue&type=style&index=0&id=4b2f23b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports